import { useState, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../redux/hooks";
import { formatNumber, formatCurrency, formatPercent } from "../../../utils/formatNumber";
import ReactTable from "react-table-6";
import ReactTablePagination from "../../../components/custom/growth/ProductsCVTablePagination";
import useColumnSelector from "../../../hooks/useColumnSelector";
import moment from "moment";
import DownloadReport from "../../perf_reports/DownloadReport";

export function MetricDebug({ filters, dashboardData }) {
  const { t } = useTranslation(["pricingv2"]);
  const [colToggle] = useState();
  const tableRef = useRef();
  const marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);

  const [columns, columnSelectorProps] = useColumnSelector(
    () => {
      const columns = [
        {
          id: "Date",
          label: t(($) => $.pricingv2.metricDebug.Date),
          key: "name",
          headerClassName: "text-center",
          headerStyle: { textAlign: "center" },
          style: { textAlign: "center" },
          accessor: "name",
          Cell: (props) => {
            return <span>{moment(props.value).format("MMM DD YYYY")}</span>;
          },
          Header: () => (
            <div className="text-center" style={{ width: "100px" }}>
              <span>{t(($) => $.pricingv2.metricDebug.Date)}</span>
            </div>
          ),
        },
        {
          id: "target_sales",
          label: t(($) => $.pricingv2.metricDebug["For. Sales"]),
          key: "target_sales",
          headerClassName: "text-center",
          headerStyle: { textAlign: "center", width: "1000px" },
          style: { textAlign: "center" },
          accessor: "target_sales",
          Cell: (props) => (
            <span>
              {formatCurrency(props.value, {
                marketPlace: marketPlace,
              })}
            </span>
          ),
          Header: () => (
            <div className="text-center" style={{ width: "100px" }}>
              <span>{t(($) => $.pricingv2.metricDebug["For. Sales"])}</span>
            </div>
          ),
        },
        {
          id: "total_sales",
          label: t(($) => $.pricingv2.metricDebug["Actual Sales"]),
          key: "total_sales",
          headerClassName: "text-center",
          headerStyle: { textAlign: "center" },
          style: { textAlign: "center" },
          accessor: "total_sales",
          Cell: (props) => (
            <span>
              {formatCurrency(props.value, {
                marketPlace: marketPlace,
              })}
            </span>
          ),
          Header: () => (
            <div className="text-center" style={{ width: "100px" }}>
              <span>{t(($) => $.pricingv2.metricDebug["Actual Sales"])}</span>
            </div>
          ),
        },
        {
          id: "inc_cashflow",
          label: t(($) => $.pricingv2.metricDebug.Cashflow),
          key: "inc_cashflow",
          headerClassName: "text-center",
          headerStyle: { textAlign: "center" },
          style: { textAlign: "center" },
          accessor: "inc_cashflow",
          Cell: (props) => (
            <span>
              {formatCurrency(props.value, {
                marketPlace: marketPlace,
              })}
            </span>
          ),
          Header: () => (
            <div className="text-center" style={{ width: "100px" }}>
              <span>{t(($) => $.pricingv2.metricDebug.Cashflow)}</span>
            </div>
          ),
        },
        {
          id: "value",
          label: t(($) => $.pricingv2.metricDebug.Contribution),
          key: "value",
          headerClassName: "text-center",
          headerStyle: { textAlign: "center" },
          style: { textAlign: "center", borderRight: "1px solid #555" },
          accessor: "value",
          Cell: (props) => (
            <span>
              {formatCurrency(props.value, {
                marketPlace: marketPlace,
              })}
            </span>
          ),
          Header: () => (
            <div className="text-center" style={{ width: "100px" }}>
              <span>{t(($) => $.pricingv2.metricDebug.Contribution)}</span>
            </div>
          ),
        },
        {
          id: "inc_contribution",
          label: t(($) => $.pricingv2.metricDebug.Contribution),
          key: "inc_contribution",
          headerClassName: "text-center",
          headerStyle: { textAlign: "center" },
          style: { textAlign: "center", borderRight: "1px solid #555" },
          accessor: "inc_contribution",
          Cell: (props) => (
            <span>
              {formatCurrency(props.value, {
                marketPlace: marketPlace,
              })}
            </span>
          ),
          Header: () => (
            <div className="text-center" style={{ width: "100px" }}>
              <span>{t(($) => $.pricingv2.metricDebug["Inc. Contribution"])}</span>
            </div>
          ),
        },
        {
          id: "reference_price",
          label: t(($) => $.pricingv2.metricDebug["Ref. Price"]),
          key: "reference_price",
          headerClassName: "text-center",
          headerStyle: { textAlign: "center" },
          style: { textAlign: "center" },
          accessor: "reference_price",
          Cell(props) {
            return (
              <div>
                {formatCurrency(props.value, {
                  marketPlace: marketPlace,
                })}
              </div>
            );
          },
          Header: () => (
            <div className="text-center" style={{ width: "100px" }}>
              <span>{t(($) => $.pricingv2.metricDebug["Ref. Price"])}</span>
            </div>
          ),
        },
        {
          id: "asp",
          label: t(($) => $.pricingv2.metricDebug.ASP),
          key: "asp",
          headerClassName: "text-center",
          headerStyle: { textAlign: "center" },
          style: { textAlign: "center" },
          accessor: "asp",
          Cell(props) {
            return (
              <div>
                {formatCurrency(props.value, {
                  marketPlace: marketPlace,
                })}
              </div>
            );
          },
          Header: () => (
            <div className="text-center" style={{ width: "100px" }}>
              <span>{t(($) => $.pricingv2.metricDebug.ASP)}</span>
            </div>
          ),
        },
        {
          id: "inc_price",
          label: t(($) => $.pricingv2.metricDebug["+/-"]),
          key: "inc_price",

          headerClassName: "text-center",
          headerStyle: { textAlign: "center" },
          style: { textAlign: "center", borderRight: "1px solid #555" },
          accessor: "inc_price",
          Cell(props) {
            return (
              <div>
                {formatCurrency(props.value, {
                  marketPlace: marketPlace,
                })}
              </div>
            );
          },
          Header: () => (
            <div className="text-center" style={{ width: "100px" }}>
              <span>{t(($) => $.pricingv2.metricDebug["+/-"])}</span>
            </div>
          ),
        },
        {
          id: "target_units",
          label: t(($) => $.pricingv2.metricDebug["For. Units"]),
          key: "target_units",
          headerClassName: "text-center",
          headerStyle: { textAlign: "center" },
          style: { textAlign: "center" },
          accessor: "target_units",
          Cell(props) {
            return <div>{formatNumber(props.value, { decimalPlaces: 0 })}</div>;
          },
          Header: () => (
            <div className="text-center" style={{ width: "100px" }}>
              <span>{t(($) => $.pricingv2.metricDebug["For. Units"])}</span>
            </div>
          ),
        },
        {
          id: "total_units",
          label: t(($) => $.pricingv2.metricDebug["Actual Units"]),
          key: "total_units",
          headerClassName: "text-center",
          headerStyle: { textAlign: "center" },
          style: { textAlign: "center" },
          accessor: "total_units",
          Cell(props) {
            return <div>{formatNumber(props.value, { decimalPlaces: 0 })}</div>;
          },
          Header: () => (
            <div className="text-center" style={{ width: "100px" }}>
              <span>{t(($) => $.pricingv2.metricDebug["Actual Units"])}</span>
            </div>
          ),
        },
        {
          id: "inc_units",
          label: t(($) => $.pricingv2.metricDebug["+/-"]),
          key: "inc_units",
          headerClassName: "text-center",
          headerStyle: { textAlign: "center" },
          style: { textAlign: "center", borderRight: "1px solid #555" },
          accessor: "inc_units",
          Cell(props) {
            return <div className="text-center">{formatNumber(props.value, { decimalPlaces: 0 })}</div>;
          },
          Header: () => (
            <div className="text-center" style={{ width: "100px" }}>
              <span>{t(($) => $.pricingv2.metricDebug["+/-"])}</span>
            </div>
          ),
        },
        {
          id: "page_views",
          label: t(($) => $.pricingv2.metricDebug["Page Views"]),
          key: "page_views",
          headerClassName: "text-center",
          headerStyle: { textAlign: "center" },
          style: { textAlign: "center" },
          accessor: "page_views",
          Cell(props) {
            return <div>{formatNumber(props.value, { decimalPlaces: 0 })}</div>;
          },
          Header: () => (
            <div className="text-center" style={{ width: "100px" }}>
              <span>{t(($) => $.pricingv2.metricDebug["Page Views"])}</span>
            </div>
          ),
        },
        {
          id: "reference_cr",
          label: t(($) => $.pricingv2.metricDebug["Ref. CR"]),
          key: "reference_cr",
          headerClassName: "text-center",
          headerStyle: { textAlign: "center" },
          style: { textAlign: "center" },
          accessor: "reference_cr",
          Cell(props) {
            return <div>{formatPercent(props.value)}</div>;
          },
          Header: () => (
            <div className="text-center" style={{ width: "100px" }}>
              <span>{t(($) => $.pricingv2.metricDebug["Ref. CR"])}</span>
            </div>
          ),
        },
      ];

      return columns;
    },
    [colToggle, t],
    "metric_debug",
  );

  return (
    <Row>
      <Col>
        <div className="table-responsive">
          <ReactTable
            ref={tableRef}
            data={dashboardData.date}
            className="pricing-table"
            PaginationComponent={(props) => {
              return (
                <ReactTablePagination
                  {...props}
                  showFilters={false}
                  style={{ marginBottom: "2rem" }}
                  hideFilters={true}
                  columnSelectorProps={columnSelectorProps}
                  hideSearch={true}
                />
              );
            }}
            defaultPageSize={20}
            // Below is needed to eliminate the no data message that covers table headers if no data to render
            NoDataComponent={() => null}
            minRows={0}
            showPaginationTop
            showPaginationBottom={false}
            filterable={false}
            columns={columns}
          />
        </div>
      </Col>
      <Col xs={6} className="text-start mt-5">
        <DownloadReport
          url_path={``}
          filters={filters}
          report_dl=""
          buttonText={t(($) => $.pricingv2["Download Report"])}
          endpoint={`/pricing/dashboard_v4_stats`}
          type="csv"
        />
      </Col>
      <Col xs={6} className="text-end mt-5">
        <a
          href="https://trellis-website.s3.us-west-2.amazonaws.com/Dynamic+Pricing+Metrics.pdf"
          target="_blank"
          rel="noreferrer"
        >
          <button className="btn btn-primary">{t(($) => $.pricingv2["Download Metric Documentation"])}</button>
        </a>
      </Col>
    </Row>
  );
}
